import t from 'tcomb';

t.struct.strict = true;
t.interface.strict = true;
